export class ListData {
    data!: {
        total: number
        list: {
        }[];
    }
}

export enum sortList {
    ASC = "ASC",
    DESC = 'DESC',
}

export class ListFilter {
    page!: number;
    perPage!: number;
    sort!: string;
    search!: string;
    sortBy!: string;
    status!: any;
}

export enum sessionStatus {
    new = "1",
    upcoming = "2",
    ongoing = "3",
    finished = "4",
    cancelled = "5"
}

export enum SessionType {
    Voice = 'voice',
    Vedio = 'video',
    Chat = 'chat',
}


export interface RequestDetailsInterface {
    request: Request
    history: History[]
}

export interface Request {
    id: string
    references_number: string
    created_at: string
    start_at: string
    price: string
    is_free: number
    type_name: string
    type: string
    status: Status
    gender: string
    user: User
    consultant: Consultant
    specialty: string
}

export interface Status {
    id: string
    name: string
}

export interface User {
    name: string
    image: string
    company: {
        company_logo: string
        name_ar: string
        name_en: string
    }
}

export interface Consultant {
    name: string
    image: string
}

export interface History {
    id: string
    created_at: string
    note?: string
    label?: string
    new_date?: string
    old_date?: string
    name: string
    user: User,
    class: string,
    rate: string
}

